import React from 'react';
import {Info} from 'lucide-react';

interface PlanFindErrorProps {
  error: string;
}

const PlanFindError: React.FC<PlanFindErrorProps> = ({ error }) => {
    return (
      <div className="p-4 my-4 text-red-800 border border-red-300 rounded-lg bg-red-50" role="alert">
        <div className="flex items-center">
          <Info className="flex-shrink-0 w-4 h-4 me-2" />
          <h3 className="text-lg font-medium">Oh snap!!!</h3>
        </div>
        <div className="my-2 text-sm">
          {error}
        </div>
      </div>
    );
  };

export default PlanFindError;
